var React = require('react');

function External (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.9181 0.998791C12.4703 1.00907 12.9096 1.46505 12.8993 2.01724L12.7318 11.0157C12.7215 11.5679 12.2655 12.0072 11.7133 11.9969C11.1611 11.9866 10.7218 11.5306 10.7321 10.9784L10.8547 4.3938L1.69382 13.2198L0.306183 11.7795L9.46708 2.9535L2.88244 2.83089C2.33025 2.8206 1.89095 2.36463 1.90123 1.81244C1.91151 1.26025 2.36749 0.820949 2.91968 0.831232L11.9181 0.998791Z","fill":"currentColor"}));
}

External.defaultProps = {"aria-hidden":"true","width":"13","height":"14","viewBox":"0 0 13 14","fill":"currentColor"};

module.exports = External;

External.default = External;
